<data-grid [settings]="grid"></data-grid>
